<template>

  <lu-vbox lu-flex class="app-container vpad-in-5" >

    <lu-vbox>
      <PageHeader title='I-Risk Monitor View' :hasList='false' :hasExport='true' :hasSettings='true' @settingsToggle='settingsToggle'>
        <template slot='beforeArea'>
          <lu-hbox lu-vcenter class='pad-in-5'>
            <lu-item>{{ $t("Historical report") }}</lu-item>
            <lu-item>
              <el-checkbox v-model="historicalReport"/>
            </lu-item>
            <lu-item>
                <el-date-picker class='historicalTimePicker'
                  clearable
                  v-model="historicalDateTime"
                  value-format='yyyyMMdd'
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  @change='historicalReport = true'
                  :picker-options="pickerOptions">
                </el-date-picker>
            </lu-item>
          </lu-hbox>
        </template>
        <template slot='extraArea'>
          <lu-hbox class='pad-in-20'>
            <el-tooltip class="item" :effect="styleTooltip" :content="$t('Reset panel layout')" placement="top">
              <lu-item class='headerIcon lu-click el-icon-s-grid' @click.stop='(e) => reload()'></lu-item>
            </el-tooltip>
            <el-tooltip class="item" :effect="styleTooltip" :content="$t('Export Excel')" placement="top">
              <lu-item class='headerIcon lu-click el-icon-download' @click.stop='onExportExcel'></lu-item>
            </el-tooltip>
            <el-tooltip class="item" :effect="styleTooltip" :content="$t('Export Layout')" placement="top">
              <lu-item class='headerIcon lu-click el-icon-document' @click.stop='onExportLayout'></lu-item>
            </el-tooltip>
          </lu-hbox>
        </template>
      </PageHeader>
    </lu-vbox>

      <right-panel sv-if='expandedSettings'>
        <SettingsMonitor :panelList='panelList' :displayed='displayedPanels'
             :currencyList='currencyList'
             :groupingList='groupingList'
             :groupingKeys='groupingKeys'
             @iRiskSubscribe='iRiskSubscribe'
             @iRiskUnsubscribe='iRiskUnsubscribe'
             @togglePanel='togglePanel'
        />

      </right-panel>

      <lu-hbox lu-flex>
        <lu-scroll-area lu-flex :scrollbarWidth='10' :scrollbarHeight='10'>
          <lu-hbox lu-flex lu-flex-wrap v-if='expandedData' sclass='pad-in-5 svpad-in-5 list' id='list' :style="currentStyle">

              <vue-draggable-resizable class-name='card-container' style='display: flex; position: absolute'
                v-for='panel in displayedPanels'
                  :id='"panelDiv-" + panel.id'
                  :key='panel.id'
                  :w="panel.options.width"
                  :h="panel.options.height"
                  :minWidth="panel.options.minWidth ? panel.options.minWidth : 200"
                  :minHeight="panel.options.minHeight ? panel.options.minHeight : 200"
                  :grid="[10,10]"
                  :drag-handle="'.drag-handle'"
                  :parent='false'
                  :parentLimitation="true"
                  :resizable='true'
                  :prevent-deactivation="false"
                  :x="panel.options.left"
                  :y="panel.options.top"
                  :z="panel.options.z"
                  :active="panel.options.active ? panel.options.active : false"
                  @activated='onActivated(panel)'
                  @resizestop='(l, t, w, h) => onResizing(panel, l, t, w, h)'
                  @resizing='(l, t, w, h) => onResizing(panel, l, t, w, h)'
                  @dragstop='(l, t) => onDragStop(panel, l, t)'
              >

                <Panel class='lu-flex'
                    :id="'panelDiv-' + panel.id"
                    :panelId='panel.id'
                    :options='panel.options'
                    :groupingKeys='groupingKeys'
                    :noPopup='!!panel.optionsNoPopup'
                    @selectedNoLimitPanel='selectedNoLimitPanel(panel)'
                    @close='minimizePanel(panel)'
                    @fullscreen='fullScreen(panel)'
                    @settings='settings(panel)'
                    @exportexcel='exportExcel(panel, false)'
                    @changeBookFilter='changeBookFilter'
                    @changeBookPnLMode='onChangeBookPnLMode(panel)'
                    @changeLotsMios='onChangeLotsMios(panel)'
                    @changeBookSet='(panelId,bookSet) => onChangeBookSet(panelId,bookSet,panel)'
                    @changeShowNetExposure='(panelId,value) => onChangeShowNetExposure(panel)'
                    sstyle='margin-bottom: 10px;'
                    :dataExposureTotal='dataExposureTotal'
                >
                    <template v-slot:options v-if='panel.optionsClass && optionsConds(panel)'>
                      <component :is='panel.optionsClass' :panel='panel' :panelId='panel.id' @getDetail='v => getDetail(1, v,panel)' @detailChangeBookFilter='detailChangeBookFilter(1)'/>
                    </template>

                    <!-- <component :ref='"panel-"+panel.id' :is='panel.class' :label='panel.options.groupKey ? groupingKeys[panel.options.groupKey] : ""'
                      :panel='panel' :data='data[panel.id]'
                      @getDetail='v => getDetail(1, v,panel)'
                      /> -->
                    <component :ref='"panel-"+panel.id' :is='panel.class' :label='panel.options.groupKey ? groupingKeys[panel.options.groupKey] : ""'
                      :panel='panel' :data='panel.dataKey ? data[panel.dataKey] : data[panel.id]' :extraData='extraData[panel.extraKey]'
                      @getDetail='v => getDetail(1, v,panel)'
                      />
                </Panel>
              </vue-draggable-resizable>
          </lu-hbox>
        </lu-scroll-area>

        <transition name='fold-right'>
          <lu-vbox v-if='detailParamsTop.show || detailParamsBottom.show' class='detail-sidebar'>
            <div class="handle-button-close" @click='closeDetailDialog(3)' >
              <i class="el-icon-close" />
            </div>
            <lu-scroll-area lu-flex :scrollbarWidth='10' dstyle='height: 100%;'>
              <DetailView ref="topDetail" 
                :detailPanelId='1' 
                @togglePageTitle='closeDetailDialog(1)' 
                v-if='detailParamsTop.show'    
                :data='detailDataTop'    
                :detailParams='detailParamsTop'    
                @getDetail='v => getDetail(2, v)' 
                @detailChangeBookFilter='detailChangeBookFilter(1)'
                @exportexcel='exportExcel("topDetail", false)'/>
              <DetailView ref="bottomDetail" 
                :detailPanelId='2' 
                @togglePageTitle='closeDetailDialog(2)'
                v-if='detailParamsBottom.show' 
                :data='detailDataBottom' 
                :detailParams='detailParamsBottom' 
                @getDetail='v => getDetail(1, v)' 
                @detailChangeBookFilter='detailChangeBookFilter(2)'
                @exportexcel='exportExcel("bottomDetail", false)'/>
            </lu-scroll-area>

          </lu-vbox>
        </transition>

    </lu-hbox>

   <!-- Minimized panel list area -->
    <lu-hbox lu-flex-wrap style='min-height: 32px;margin-left: 5px;' class='pad-in-5'>
      <lu-hbox lu-vcenter class='minimizedPanel' v-for='panel in minimizedPanels' :key='panel.id' @click='maximizePanel(panel)'>
        <lu-item lu-flex>{{ panel.options.title }}</lu-item>
        <span class="svg-container" >
          <svg-icon icon-class="lock" class='icon negative' />
        </span>
      </lu-hbox>
    </lu-hbox>

  </lu-vbox>
</template>

<script>
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import { LuVbox, LuHbox, LuScrollArea, LuItem } from 'lusis-ui'
import vueDraggableResizable from 'vue-draggable-resizable'
import RightPanel from '@/components/RightPanel'
import BottomPanel from '@/components/BottomPanel'
import PageHeader from '@/components/PageHeader'
import InstrExpArray from './instrExpArray'
import InstrPnLArray from './instrPnLArray'
import PnLReport from './pnlReport'
import Client from './client'
import Order from './order'
import Exposure from './exposure'
import HedgeArray from './hedgeArray'
import BookSummary from './bookSummary'
import BookPnL from './bookPnL'
import STPPnL from './STPPnL'
import FlowArray from './FlowArray'
import BookAggregation from './bookAggregation'
import BookDiscrepancies from './bookDiscrepancies'
import CreditControl from './creditControl'
import Reconciliation from './reconciliation'
import Risk from './risk'
import RiskSplit from './riskSplit'
import NTPLP from './NTPLP'
import Panel from './panel'
import utilsMixin from '@/mixins/utils'
import PanelConfig from './panelConfig'
import SettingsMonitor from './components/settingsMonitor'
import SettingsLot from './components/settingsLot'
import SettingsCategory from './components/settingsCategory'
import SettingsBook from './components/settingsBook'
import SettingsMode from './components/settingsMode'
import DetailView from './detailView'
import { mapState, mapGetters, mapActions } from 'vuex'
import { timestamp } from '@/utils'
import UtilNumber from '@/utils/formatNumber'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import elDragDialog from '@/directive/el-dragDialog'
import screenfull from 'screenfull'
import { deepClone } from '@/utils'

export default {
  name: 'iriskMonitor',
  mixins: [ utilsMixin ],
  components: { BottomPanel, DetailView, SettingsMode, LuItem, vueDraggableResizable, PageHeader, SettingsLot, RightPanel, LuHbox, LuVbox, LuScrollArea, SettingsMonitor, InstrExpArray, InstrPnLArray, HedgeArray, BookSummary, SettingsCategory, Panel, Exposure, PnLReport, Client, Order, BookPnL, STPPnL, SettingsBook, FlowArray, BookAggregation, BookDiscrepancies, CreditControl, Reconciliation, Risk, RiskSplit, NTPLP },
  directives: { elDragDialog },
  created () {
    this.getBookPlatformName()
    this.getBookSetList()
    this.getBookAssetList()
    PanelConfig.reload()
    this.reload(true)
    this.dataInit(true)
    document.addEventListener('fullscreenchange', this.screenfullHandler, false);
    document.addEventListener('mozfullscreenchange', this.screenfullHandler, false);
    document.addEventListener('MSFullscreenChange', this.screenfullHandler, false);
    document.addEventListener('webkitfullscreenchange', this.screenfullHandler, false);
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.saveDisplayedPanelList)
  },
  beforeDestroy () {
    document.removeEventListener('fullscreenchange', this.screenfullHandler, false);
    document.removeEventListener('mozfullscreenchange', this.screenfullHandler, false);
    document.removeEventListener('MSFullscreenChange', this.screenfullHandler, false);
    document.removeEventListener('webkitfullscreenchange', this.screenfullHandler, false);

    if (this.detailParamsTop.show) this.unsubscribeDetail('topDetail')
    if (this.detailParamsBottom.show) this.unsubscribeDetail('bottomDetail')
    this.iRiskUnsubscribe()
    this.deleteBookList()
    this.saveDisplayedPanelList()
    window.removeEventListener("beforeunload", this.saveDisplayedPanelList)
  },
  watch: {
    historicalReport () {
      this.iRiskUnsubscribe(false)
      this.iRiskSubscribe(this.conditions)
    },
    historicalDateTime () {
      if (this.historicalReport) {
        this.iRiskUnsubscribe(false)
        this.iRiskSubscribe(this.conditions)
      }
    }
  },
  data () {
    return {
      expandedSettings: false,
      toggleCcy: true,
      expandedData: true,
      numRows: 1,
      data: {},
      extraData: {},
      list: [],
      groupingKeys: {},
      displayedPanels: [],
      minimizedPanels: [],
      dragging: null,
      maxz: 0,
      detailDataTop: {},
      detailDataBottom: {},
      detailParamsTop: {title: null, type: null, value: null, params: [], show: false},
      detailParamsBottom: {title: null, type: null, value: null, params: [], show: false},
      historicalReport: false,
      historicalDateTime: null,
      conditions: {},
      pickerOptions: {
        shortcuts: [{
          text: 'Last week',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: 'Last month',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: 'Last 3 months',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters(['userInfos', 'tangoStatus']),
    ...mapState({ currencySelected: state => state.settingsMonitor.settingParams.currency }),
    ...mapState({ detailParams: state => state.settingsMonitor.detailParams }),
    ...mapState({ groupKeys: state => state.settingsMonitor.settingParams.changeGrouping }),
    ...mapState({ countVal: state => state.settingsMonitor.settingParams.count }),
    ...mapState({ settingsDisplayedPanels: state => state.settingsMonitor.settingParams.settingsDisplayedPanels }),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    },
    createOrUpdate: function () {
      return this.$t('I-RISK MONITOR')
    },
    dataExposureTotal: function () {
      let res = {}
      if (this.data['ccyExposure']) {
        let tmp = this.data['ccyExposure'].filter(item => item.currency === '')
        if (tmp) return tmp[0]
      }
      return res
    },
    panelList: function () {
      return this.list
    },
    groupingList: function () {
      return PanelConfig.getGroupKeyList()
    },
    currencyList: function () {
      let curs = {}
      for (let name in this.data) {
        if (name !== 'groupingKeys') {
          if (!Array.isArray(this.data[name])) {
            for (let sub in this.data[name]) {
              this.data[name][sub].forEach(d => {
                if (d.currency) curs[d.currency] = 1
              })
            }
          }
          else {
            this.data[name].forEach(d => {
              if (d.currency) curs[d.currency] = 1
            })
          }
        }
      }

      let arr = []
      for (let name in curs) arr.push(name)
      if (arr.length === 0) arr.push(this.currencySelected)
      return arr.sort((a, b) => a < b ? -1 : a > b ? 1 : 0)
    },
    maxHeight () {
      if (this.displayedPanels && this.displayedPanels.length) {
        let panel = this.displayedPanels.reduce((p, c) => (p.options.top + p.options.height) > (c.options.top + c.options.height) ? p : c)
        if (panel) {
          return panel.options.top + panel.options.height + 100
        }
      }
      return null
    },
    maxWidth () {
      if (this.displayedPanels && this.displayedPanels.length) {
        let panel = this.displayedPanels.reduce((p, c) => (p.options.left + p.options.width) > (c.options.left + c.options.width) ? p : c)
        if (panel) {
          return panel.options.left + panel.options.width + 100
        }
      }
      return null
    },
    currentStyle () {
      return {
        'height': this.maxHeight ? `${this.maxHeight}px` : null,
        'width': this.maxWidth ? `${this.maxWidth}px` : '100vw',
        'margin-left': '10px',
        'position': 'relative'
      }
    }
  },
  methods: {
    ...mapActions('iRiskMonitor', [ 'setBookList', 'deleteBookList', 'setBookSetList', 'setBookAssetList' ]),

    onExportExcel: function () {
      let sheets = []
      this.panelList.forEach(panel => {
        if (panel.subMenu) {
          panel.subMenu.forEach(subpanel => {
            if (subpanel) this.addExportSheets(panel, sheets, subpanel.exportExcel, subpanel.exportExcelFilePrefix, subpanel.id)
          })
        } 
        else this.addExportSheets(panel, sheets)
      })

      if (this.detailParamsTop.show) this.addExportSheets("topDetail", sheets)
      if (this.detailParamsBottom.show) this.addExportSheets("bottomDetail", sheets)

      Promise.all(sheets).then(data => {
        let sheets = []
        data.forEach(sheet => {
          if (sheet && sheet.isMultiTab) {
            sheets = sheets.concat(sheet.tabList)
          } else {
            if (sheet && sheet.sheetName && sheet.data) {
              sheets.push(sheet)
            }
          }
        })
        if (sheets.length) {
          import('@/vendor/Export2Excel').then(excel => {
            let filename = 'BrokerHUB_Export_' +  timestamp()
            excel.export_json_to_excel_lusis_multisheet({
              filename: filename,
              autoWidth: true,
              bookType: 'xlsx',
              sheets: sheets
            })
          })
        }
      })
    },
    onExportLayout: function () {
      const dataStr = JSON.stringify(this.displayedPanels, null, 2);
      const blob = new Blob([dataStr], { type: "application/json" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "layout-config.json";
      link.click();

      URL.revokeObjectURL(url);
    },
    addExportSheets (panel, sheets, exportExcel = '', exportExcelFilePrefix = '', panelId = '') {
      let sheet = this.exportExcel(panel, true, exportExcel, exportExcelFilePrefix, panelId)
      if (sheet) {
        if (sheet instanceof Promise) {
          if (sheet && sheet.isMultiTab) {
            sheets = sheets.concat(sheet.tabList)
          } else {
            sheets.push(sheet)
          }
        }
        else if (Array.isArray(sheet)) {
          sheets.push(new Promise(resolve => {
            resolve(sheet)
          }))
        }
      }
    },
    setList: function (isCreate = false) {
      this.list = (isCreate) ? PanelConfig.getPanelConfig() : PanelConfig.reloadPanelConfig()
      this.maxz = this.list.reduce((max, panel) => panel.options.z > max ? panel.options.z : max, 0) + 1
    },
    closeDetailDialog: function (id) {
      if (id & 1) {
        this.unsubscribeDetail('topDetail')
        this.detailParamsTop = {title: null, type: null, value: null, params: [], show: false}
      }
      if (id & 2) {
        this.unsubscribeDetail('bottomDetail')
        this.detailParamsBottom = {title: null, type: null, value: null, params: [], show: false}
      }
    },
    unsubscribeDetail: function (id) {
      if (this.$tango.isConnected()) {
        this.$tango.iRiskMonitorUnsubscribeDetail(id, this.$store.getters.userInfos.netId)
      }
    },
    subscribeDetail: function (id, type, params) {
      let cond = {
        sorting: id,
        customerOrderId: this.$store.getters.userInfos.netId,
        parameterList: params
      }
      return this.$tango.iRiskMonitorSubscribeDetail(cond).then(rep => {
        if (rep.resultCode) {
          this.$message({
            message: 'Error response from Tango',
            type: 'error'
          })
        }
        else {
          this.updateClientExtraInfo(rep)
          this.updateClientTitleInfo(rep)
          let rootLabel = 'positionList'
          if (type.toLowerCase() === 'symbol' || type.toLowerCase() === 'flow') {
            rootLabel = 'dossierList'
          }
          else if (type.toLowerCase() === 'account') {
            rootLabel = 'instrumentList'
          }
          if (rep[rootLabel] && rep[rootLabel].length !== 0) {
            return {
              'extraInfo': rep.extraInfo,
              'titleInfo': rep.titleInfo,
              'detail': rep[rootLabel]
            }
          }
        }
        return []
      }).catch(() => {})
    },
    getInitDetailBookFilterParams(id,panel,params) {
      var panelParamList= []
      var newId = ""
      var ptf = ""
      var book = ""
      var defaultPlatform = ""
      var defaultBookName = ""

      if (params!==null && params!==undefined) {
        if (params.hasOwnProperty('platform')) {
          defaultPlatform = params.platform
        }
        if (params.hasOwnProperty('bookName')) {
          defaultBookName = params.bookName
        }
      }

      if (panel !==null && panel !== undefined && panel.hasOwnProperty('bookFilterId')) {
        panelParamList = deepClone(this.conditions.parameterList.filter(p => p.paramName === panel.bookFilterId+'.Ptf' || p.paramName === panel.bookFilterId+'.Book'))
        if (id === 1)
          newId = 'topDetail'
        else
          newId = 'bottomDetail'

        //selected default book
        if (!panelParamList.length) {
          panelParamList.push({
              'paramName': panel.bookFilterId +'.Ptf',
              'paramValue': defaultPlatform,
              // 'paramValue': "",
          })
          panelParamList.push({
              'paramName': panel.bookFilterId +'.Book',
              'paramValue': defaultBookName,
              // 'paramValue': "",
          }) 
        }

        if (newId !== "" && panelParamList.length) {
          panelParamList.forEach(p => {
            if (p.paramName === panel.bookFilterId+'.Ptf') {
              ptf = p.paramValue
              p.paramName = newId+'.Ptf'
            }
            else if (p.paramName === panel.bookFilterId+'.Book') {
              book = p.paramValue
              p.paramName = newId+'.Book'
            }

          })
          return { value:[ptf,book], params: panelParamList }
        }
      }
      return { value:[], params:[] }
    },
    getDetail: function (id, params,panel) {
      var initDetailBookParams = this.getInitDetailBookFilterParams(id,panel,params)

      if (id === 1) {
        // if (this.detailParamsTop.show) this.unsubscribeDetail('topDetail')
        this.detailParamsTop = params
        if (panel!== null && panel !== undefined) {
          this.detailParamsTop.params = params.params.concat(initDetailBookParams.params)
        }
        else {
          this.detailParamsTop.params = params.params.concat(this.getDetailBookFilterParams(id))
        }
        if (this.detailParamsTop.show) {
          this.subscribeDetail('topDetail', params.type, params.params).then(rep => {
            if (panel!== null && panel !== undefined)
              this.setDetailBookFilterParams(id,initDetailBookParams.value)
            this.detailDataTop = Object.assign({}, rep)
          })
        }
      }
      else {
        // if (this.detailParamsBottom.show) this.unsubscribeDetail('bottomDetail')
        this.detailParamsBottom = params
        if (panel!== null && panel !== undefined) {
          this.detailParamsBottom.params = params.params.concat(initDetailBookParams.params)
        }
        else {
          this.detailParamsBottom.params = params.params.concat(this.getDetailBookFilterParams(id))
        }
        if (this.detailParamsBottom.show) {
          this.subscribeDetail('bottomDetail', params.type, params.params).then(rep => {
            if (panel!== null && panel !== undefined)
              this.setDetailBookFilterParams(id,initDetailBookParams.value)
            this.detailDataBottom = Object.assign({}, rep)
          })
        }
      }
    },
    onActivated(panel) {
      panel.options.z = ++this.maxz
      this.$store.dispatch('settingsMonitor/changeOptionSetting', panel)
    },
    onDragStop(panel, l, t) {
      panel.options.left = l
      panel.options.top = t
      this.$store.dispatch('settingsMonitor/changeOptionSetting', panel)
    },
    onResizing(panel, l, t, w, h) {
      panel.options.width = w
      panel.options.height = h
      panel.options.left = l
      panel.options.top = t
      this.$store.dispatch('settingsMonitor/changeOptionSetting', panel)
    },
    maximizePanel (panel) {
      let idx = this.minimizedPanels.findIndex(p => p.id === panel.id)
      if (idx !== -1) {
        let p = this.minimizedPanels.splice(idx, 1)[0]
        this.displayedPanels.push(p)
      }
    },
    minimizePanel (panel) {
      let idx = this.displayedPanels.findIndex(p => p.id === panel.id)
      if (idx !== -1) {
        let p = this.displayedPanels.splice(idx, 1)[0]
        this.minimizedPanels.push(p)
      }
    },
    screenfullHandler: function () {
      if (document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement !== null)
        this.$store.dispatch('app/toggleRiskFullScreen', screenfull.isFullscreen)
    },
    fullScreen (panel) {
      if (!screenfull.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle(document.getElementById('panelDiv-' + panel.id)).then(() => {
        this.$store.dispatch('app/toggleRiskFullScreen', screenfull.isFullscreen)
      })
    },
    settings (panel) {
      if (this.$refs['panel-' + panel.id] && this.$refs['panel-' + panel.id].length) {
        this.$refs['panel-' + panel.id][0].onSettings()
      }
    },
    exportExcel (panel, sheetOnly, exportExcel='', exportExcelFilePrefix='', panelId='') {
      //top + bottom detail view
      if (this.$refs[panel] && this.$refs[panel].onExportExcel) {
        return this.$refs[panel].onExportExcel(!!sheetOnly, panel, panel)
      }
      else if (this.$refs['panel-' + panel.id] && this.$refs['panel-' + panel.id].length && this.$refs['panel-' + panel.id][0].onExportExcel) {
        return this.$refs['panel-' + panel.id][0].onExportExcel(!!sheetOnly, exportExcel, exportExcelFilePrefix, panelId)
      }
      return null
    },
    optionsConds (panel) {
      if (!panel.optionsConds || !panel.optionsClass) return true
      let result = true
      panel.optionsConds.forEach(cond => {
        if (cond.groupKey) {
          if (this.groupingKeys[panel.options.groupKey] !== cond.groupKey) result = false;
        }
      })
      return result
    },
    close: function () {
      this.toggleCcy = !this.toggleCcy
    },
    pageControllerName: function () {
      return 'iriskMonitor'
    },
    settingsToggle: function () {
      this.$store.dispatch('settingsMonitor/toggleRightPanel')
      this.expandedSettings = !this.expandedSettings
    },
    togglePanel: function (obj) {
      if (obj.force) {
        if (obj.selected) {
          this.panelList.forEach(item => {
            let idx = this.displayedPanels.findIndex(p => p.id === item.id)
            if (idx === -1) this.displayedPanels.push(item)
          })
          this.minimizedPanels = []
        }
        else {
          this.panelList.forEach(item => {
            let idx = this.minimizedPanels.findIndex(p => p.id === item.id)
            if (idx === -1) this.minimizedPanels.push(item)
          })
          this.displayedPanels = []
        }
        return
      }
      let idx = this.displayedPanels.findIndex(p => p.id === obj.id)
      if (idx !== -1) {
        this.minimizedPanels.push(this.displayedPanels[idx])
        this.displayedPanels.splice(idx, 1)
      }
      else {
        let idx = this.minimizedPanels.findIndex(p => p.id === obj.id)
        if (idx !== -1) {
          this.displayedPanels.push(this.minimizedPanels[idx])
          this.minimizedPanels.splice(idx, 1)
        }
      }
    },
    // limitCount: function (count) {
    //   this.count = parseInt(count)
    // },
    selectedNoLimitPanel: function (panel) {
      this.iRiskUnsubscribe(true)
      this.iRiskSubscribe(this.conditions)
      panel.options.noLimit = typeof panel.options.noLimit !== 'undefined' ? !panel.options.noLimit : true
      // panel.options.height = panel.options.height > 600 ? panel.options.height : 600 // Math.min(600, (panel.options.height + 50))
      this.$store.dispatch('settingsMonitor/changeOptionSetting', panel)
    },
    onChangeBookPnLMode: function (panel) {
      panel.options.bookPnLMode = panel.options.bookPnLMode ? 0 : 1 //invert flag
      this.$store.dispatch('settingsMonitor/changeOptionSetting', panel)

      if (this.$refs['panel-' + panel.id] && this.$refs['panel-' + panel.id].length) {
        this.$refs['panel-' + panel.id][0].onChangeBookPnLMode()
      }
    },
    onChangeLotsMios: function (panel) {
      panel.options.lotsMios = !!panel.options.lotsMios && panel.options.lotsMios === 'lots' ? 'mios' : 'lots' //invert flag
      this.$store.dispatch('settingsMonitor/changeOptionSetting', panel)

      if (this.$refs['panel-' + panel.id] && this.$refs['panel-' + panel.id].length) {
        this.$refs['panel-' + panel.id][0].onChangeLotsMios()
      }
    },
    onChangeShowNetExposure: function (panel) {
      panel.options.showNetExposure = !panel.options.showNetExposure //invert flag
      this.$store.dispatch('settingsMonitor/changeOptionSetting', panel)

      if (this.$refs['panel-' + panel.id] && this.$refs['panel-' + panel.id].length && this.$refs['panel-' + panel.id][0].onChangeShowNetExposure) {
        this.$refs['panel-' + panel.id][0].onChangeShowNetExposure()
      }
    },
    onChangeBookSet: function (panelId, bookSet, panel) {
      panel.options.bookSet = bookSet
      this.$store.dispatch('settingsMonitor/changeOptionSetting', panel)

      // update bookSet panels
      for (const p of ['BookPnL', 'BookPnL1', 'BookPnL2']) {
        if (p !== panelId) {
          let tmp = this.getPanelData(p)
          if (tmp && tmp.options) {
            tmp.options.bookSet = bookSet
            this.$store.dispatch('settingsMonitor/changeOptionSetting', tmp)
          }
        }  
      } 

      this.iRiskUnsubscribe(true)
      this.iRiskSubscribe(this.conditions)
    },
    needSubscriptionUpdate: function (panelId) {
      let panel = this.getPanelData(panelId)
      // let panel = this.getPanelData('BookPnL')
      if (panel && panel.options && this.conditions) {
        return panel.options.bookSet!== this.conditions.bookSet
      }
      return false
    },
    initBookSetConditions: function (panelId) {
      let panel = this.getPanelData(panelId)
      // let panel = this.getPanelData('BookPnL')
      if (panel && panel.options) {
        this.conditions.bookSet = panel.options.bookSet
      }
    },
    getPanelData: function (panelId) {
      for (let dataList of [this.displayedPanels, this.minimizedPanels]) {
        let idx = dataList.findIndex(p => p.id === panelId)
        if (idx !== -1) {
          return dataList[idx]
        }
      }
    },
    onIRiskUpdate: function (msg) {
      PanelConfig.updatePanelData(msg, this.data, this.groupingKeys, this.countVal, this.extraData)

      // dynamic title
      let updateTitlePanelList = PanelConfig.panelList.filter(p => p.options.updateTitle)
      if (updateTitlePanelList) {
        updateTitlePanelList.forEach(p => {
          let idx = this.displayedPanels.findIndex(item => item.id === p.id)
          if (idx != -1 && this.displayedPanels[idx] && this.displayedPanels[idx].options) {
            this.displayedPanels[idx].options.title = p.options.title
          }
        })
      }

      //process for detail
      msg.exportList.forEach(item => {
        if (item.sorting === 'topDetail') {
          this.updateDetailData('topDetail', this.detailParamsTop, item)
        }
        else if (item.sorting === 'bottomDetail') {
          this.updateDetailData('bottomDetail', this.detailParamsBottom, item)
        }
      })
    },
    updateClientExtraInfo: function (msg) {
      msg.extraInfo = {
        'brokerName': msg.brokerName ? msg.brokerName : '',
        'accountNumber': msg.accountNumber ? msg.accountNumber : '',
        'accountName': msg.accountName ? msg.accountName : ''
      }
    },
    updateClientTitleInfo: function (msg) {
      msg.titleInfo = []
      if (msg.AccountEquity) {
        msg.titleInfo.push({
          'label': 'AccountEquity',
          'val': msg.AccountEquity,
          'value': UtilNumber.formatAmount(msg.AccountEquity || 0, 2)
        })
      }
      if (msg.CashMnt) {
        msg.titleInfo.push({
          'label': 'CashMnt',
          'val': msg.CashMnt,
          'value': UtilNumber.formatAmount(msg.CashMnt || 0, 2)
        })
      }
      if (msg.FreeMargin) {
        msg.titleInfo.push({
          'label': 'FreeMargin',
          'val': msg.FreeMargin,
          'value': UtilNumber.formatAmount(msg.FreeMargin || 0, 2)
        })
      }
      if (msg.usedMargin) {
        let perc = '0'
        if (msg.usedMarginPerc) perc = msg.usedMarginPerc
        msg.titleInfo.push({
          'label': 'usedMargin',
          'val': msg.usedMargin,
          'value': UtilNumber.formatAmount(msg.usedMargin || 0, 2) + ' ( ' + perc + ' % )'
        })
      }
      if (msg.nop) {
        msg.titleInfo.push({
          'label': 'NOP',
          'val': msg.nop,
          'value': UtilNumber.formatAmount(msg.nop || 0, 2, 3)
        })
      }
    },
    updateDetailData: function (id, params, data) {
      let rootLabel = 'positionList'
      if (params && params.type) {
        if (params.type.toLowerCase() === 'symbol' || params.type.toLowerCase() === 'flow') {
          rootLabel = 'dossierList'
        }
        else if (params.type.toLowerCase() === 'account') {
          rootLabel = 'instrumentList'
        }
      }
      let newData = []
      if (data[rootLabel] && data[rootLabel].length !== 0) {
        newData = data[rootLabel]
      }
      this.updateClientExtraInfo(data)
      this.updateClientTitleInfo(data)
      if (id === 'topDetail') {
        this.$set(this.detailDataTop, 'detail', newData)
        this.$set(this.detailDataTop, 'extraInfo', data.extraInfo)
        this.$set(this.detailDataTop, 'titleInfo', data.titleInfo)
        // this.detailDataTop['detail'] = newData
        // this.detailDataTop['extraInfo'] = data.extraInfo
        // this.detailDataTop['titleInfo'] = data.titleInfo
      } else {
        this.$set(this.detailDataBottom, 'detail', newData)
        this.$set(this.detailDataBottom, 'extraInfo', data.extraInfo)
        this.$set(this.detailDataBottom, 'titleInfo', data.titleInfo)
        // this.detailDataBottom['detail'] = newData
        // this.detailDataBottom['extraInfo'] = data.extraInfo
        // this.detailDataBottom['titleInfo'] = data.titleInfo
      }
    },
    iRiskSubscribe: function (cond) {
      this.conditions = cond
      this.conditions.parameterList = this.conditions.parameterList.filter(p => p.paramName !== 'dateFrom' && p.paramName !== 'dateTo')

      this.initBookSetConditions('BookPnL')
      // this.initBookSetConditions()

      if (this.historicalReport) {
        if (this.historicalDateTime && this.historicalDateTime.length === 2) {
          this.conditions.parameterList.push({
            paramName: 'dateFrom',
            paramValue: this.historicalDateTime[0]
          })
          this.conditions.parameterList.push({
            paramName: 'dateTo',
            paramValue: this.historicalDateTime[1]
          })
        }
      }
      if (this.$tango.isConnected()) {
        this.$tango.iRiskMonitorSubscribe(this.conditions, this, this.onIRiskUpdate).then(rep => {
          if (rep.resultCode === 0) {
            //update BookConfig mode
            this.$store.dispatch('settingsMonitor/changeSetting', {
              key: 'bookConfigMode',
              value: rep.isBook
            })

            this.onIRiskUpdate(rep)
          }
        })
      }
    },
    iRiskUnsubscribe: function (reset) {
      if (this.$tango.isConnected()) {
        this.$tango.iRiskMonitorUnsubscribe(this, this.onIRiskUpdate).then(() => {
          this.dataInit(reset)
        })
      }
    },
    cloneVar: function (data) {
      if (Array.isArray(data)) {
        let ret = []
        for (let i = 0; i < data.length; i++) {
          this.$set(ret, i, this.cloneVar(data[i]))
        }
        return ret
      }
      else if (typeof data === 'object') {
        let ret = {}
        for (let k in data) {
          this.$set(ret, k, this.cloneVar(data[k]))
        }
        return ret
      }
      else return data
    },
    clonePanels: function (isCreate = false, adjust = false) {
      let displayedIdx = 0
      let minimizedIdx = 0

      if (adjust && !isCreate) {
        this.adjustLayout()
      }

      this.panelList.forEach(p => {
        let panel = this.cloneVar(p)
        if (isCreate) {
          if (this.settingsDisplayedPanels.findIndex(item => item.id === panel.id) === -1) {
            this.$set(this.minimizedPanels, minimizedIdx++, panel)
          } else {
            this.$set(this.displayedPanels, displayedIdx++, panel)
          }
        }
        else {
          //reload => display all panels
          this.$set(this.displayedPanels, displayedIdx++, panel)
        }
        this.$store.dispatch('settingsMonitor/changeOptionSetting', panel) 
      })
    },
    intersectPanel: function (p1, p2) {
      return !(p2.options.left > (p1.options.left + p1.options.width) || 
              (p2.options.left + p2.options.width) < p1.options.left || 
              p2.options.top > (p1.options.top + p1.options.height) ||
              (p2.options.top + p2.options.height) < p1.options.top)
    },
    intersectPanels: function () {
      for (const panel1 of this.panelList) {
        for (const panel2 of this.panelList) {
          if (panel1===panel2) continue
          if (this.intersectPanel(panel1,panel2)) return true
        }
      }
      return false
    },
    reload: function (isCreate = false) {
      this.setList(isCreate)
      this.minimizedPanels = []
      this.displayedPanels = []
      if (isCreate) {
        //verify layout
        if (isCreate) {
          if (this.intersectPanels()) {
            // layout reset
            isCreate = false
            this.setList(isCreate)
          }
        }

        this.clonePanels(isCreate)
      }
      else {
        NProgress.start()
        this.$nextTick().then(() => {
          this.clonePanels(isCreate, true)
          if (this.needSubscriptionUpdate('BookPnL') || this.needSubscriptionUpdate('BookPnL1') || this.needSubscriptionUpdate('BookPnL2')) {
            this.iRiskUnsubscribe(true)
            this.iRiskSubscribe(this.conditions)
          }
          NProgress.done()
        })
      }
    },
    adjustLayout () {
      const margin = 20
      const screenWidth = this.$vssWidth * 0.8
      if (this.panelList && this.panelList.length) {
        for (let i = 0; i < this.panelList.length; i++) {
          const panel = this.panelList[i]
          if (panel) {
            if (i === 0) {
              panel.options.left = 0
              panel.options.top = 0
            } else {
              const lastPanel = this.panelList[i - 1]
              if (lastPanel) {
                if ((lastPanel.options.left + lastPanel.options.width + margin + panel.options.width) > screenWidth) {
                  panel.options.left = 0
                  panel.options.top = lastPanel.options.top + lastPanel.options.height + margin
                } else {
                  panel.options.left = lastPanel.options.left + lastPanel.options.width + margin
                  panel.options.top = lastPanel.options.top
                }
              }
            }
          }
        }
      }
    },
    dataInit: function (reset) {
      this.data = {}
      this.extraData = {}
      this.panelList.forEach(p => {
        if (p.id) {
          let val = []
          if (p.subMenu) {
            val = {}
            p.subMenu.forEach(s => {
              val[s.id] = []
            })
          }
          this.$set(this.data, p.id, val)
        }
      })
      if (reset) {
        this.groupingKeys = {}
        PanelConfig.getGroupKeyList().forEach(k => {
          let val = this.groupKeys[k.key] || k.default
          this.$set(this.groupingKeys, k.key, val)
        })
      }
      // S06 : LSC 78050
      this.$store.dispatch('settingsMonitor/changeSetting', {
        key: 'changeGrouping',
        value: this.groupingKeys
      })
    },
    getDetailBookFilterParams: function (id) {
      var bookFilterId = ''
      var params = []
      var value = null
      if (id === 1) {
        bookFilterId = 'topDetail'
        if (this.$refs.topDetail !== undefined && this.$refs.topDetail !== null)
          value = this.$refs.topDetail.value
      }
      else {
        bookFilterId = 'bottomDetail'
        if (this.$refs.bottomDetail !== undefined && this.$refs.bottomDetail !== null)
          value = this.$refs.bottomDetail.value
      }

      if (value !== undefined && value !== null) {
        var platform = value[0] === undefined || value[0] === null ? "" : value[0]
        var bookName = value[1] === undefined || value[1] === null ? "" : value[1]
        
        params.push({
            'paramName': bookFilterId+'.Ptf',
            'paramValue': platform,
        })
        params.push({
            'paramName': bookFilterId+'.Book',
            'paramValue': bookName,
        })      
      }
      return params
    },
    setDetailBookFilterParams: function (id,initDetailBookParams) {
      if (id === 1) {
        if (this.$refs.topDetail !== undefined && this.$refs.topDetail !== null) {
          this.$refs.topDetail.setBookFilterValue(initDetailBookParams)
        }
      }
      else {
        if (this.$refs.bottomDetail !== undefined && this.$refs.bottomDetail !== null) {
          this.$refs.bottomDetail.setBookFilterValue(initDetailBookParams)
        }
      }
    },
    changeBookFilter (panelId, bookFilterId, platform, bookName) {
      //delete old params
      this.conditions.parameterList = this.conditions.parameterList.filter(p => p.paramName !== bookFilterId+'.Ptf' && p.paramName !== bookFilterId+'.Book' && p.paramName !== 'topDetail.Ptf' && p.paramName !== 'topDetail.Book' && p.paramName !== 'bottomDetail.Ptf' && p.paramName !== 'bottomDetail.Book')

      //add book filter params
      //panels
      this.conditions.parameterList.push({
        'paramName': bookFilterId+'.Ptf',
        'paramValue': platform,
      })
      this.conditions.parameterList.push({
        'paramName': bookFilterId+'.Book',
        'paramValue': bookName,
      })

      //topDetail
      this.conditions.parameterList = this.conditions.parameterList.concat(this.getDetailBookFilterParams(1))
      //bottomDetail
      this.conditions.parameterList = this.conditions.parameterList.concat(this.getDetailBookFilterParams(2))

      //refresh  subscriptions
      this.iRiskUnsubscribe(true)
      this.iRiskSubscribe(this.conditions)
    },
    detailChangeBookFilter: function (id) {
       var bookFilterId = ''
       var params = {}
      if (id === 1) {
        bookFilterId = 'topDetail'
        params = this.detailParamsTop
      }
      else {
        bookFilterId = 'bottomDetail'
        params = this.detailParamsBottom
      }

      if (bookFilterId !== '') {
        //delete old params
        params.params = params.params.filter(p => p.paramName !== bookFilterId+'.Ptf' && p.paramName !== bookFilterId+'.Book')

        this.getDetail(id,params)
      }
    },
    getBookPlatformName () {
      return this.$tango.getBookPlatformName().then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : getBookPlatformName')
        } else {
          let bookList = []

          if (rep.brokerList && rep.brokerList.length) {
            rep.brokerList.forEach(broker => {
              if (broker) {
                let node = {
                  label: broker.brokerName,
                  value: broker.brokerName,
                  children: [],
                }

                if (broker.bookList && broker.bookList.length) {
                  broker.bookList.forEach(book => {
                    if (book) {
                      let childNode = {
                        label: book.bookName,
                        value: book.bookName,
                      }
                      node.children.push(childNode)
                    }
                  })
                }
                bookList.push(node)
              }
            })
          }
          this.setBookList(bookList)
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    getBookSetList () {
      return this.$tango.request({ MTI: 4989, functionId: 'getBookSetList' }).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : getBookSetList')
        } else {
          let bookSetList = []

          if (rep.bookList && rep.bookList.length) {
            bookSetList = rep.bookList
          }
          //sort by bookSet asc
          bookSetList.sort((a, b) => a.bookSet < b.bookSet ? -1 : a.bookSet > b.bookSet ? 1 : 0)

          this.setBookSetList(bookSetList)
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    getBookAssetList () {
      return this.$tango.request({ MTI: 4989, functionId: 'getBookAsset' }).then(rep => {
        if (rep.resultCode !== 0) {
          throw new Error('ERROR : getBookAsset')
        } else {
          let bookAssetList = []

          if (rep.assetList && rep.assetList.length) {
            bookAssetList = rep.assetList
          }

          this.setBookAssetList(bookAssetList)
        }
      }).catch(err => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
    },
    saveDisplayedPanelList: function() {
      this.$store.dispatch('settingsMonitor/changeSetting', {
        key: 'settingsDisplayedPanels',
        value: deepClone(this.displayedPanels)
      })
    },
  }
}
</script>

<style lang="scss">

@import '@/styles/mixin.scss';
.card-container {
  @include fontSize(13px);
  width: auto;
  height: auto;
  min-width: 200px;
  min-height: 130px;
  border-radius: 5px;
  margin: 10px 0px;
  background-color: blue;
  // padding: 10px;

	&.blowUp{
		animation:blowUp .5s;
		animation-fill-mode: forwards;
	}
	&.collapse{
		animation:collapse .5s;
		//animation-fill-mode: forwards;
	}

	@keyframes blowUp{
		from{
			width:330px;
			height:270px;
		}
		to{
			width:400px;
			height:340px;
		}
	}
	@keyframes collapse{
		from{
			width:400px;
			height:340px;
		}
		to{
			width:330px;
			height:270px;
		}
	}

	.card-header {
		display:flex;
		width:100%;
		height:55px;
		max-height:55px;
		align-items:center;
    justify-content:space-between;
    border-radius: 5px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: unset;
    padding: 0 10px;
		flex-shrink: 0;

		.cardIcon {

			position:relative;

      &.iconActive {
        color: rgb(0, 255, 64);
      }
			&.moveRight{
				animation-name:moveRight;
				animation-duration:.2s;
				animation-fill-mode: forwards;
				animation-timing-function:ease-in;
			}

			@keyframes moveRight{
				from{right:0px;}
				to{right:5px;}
			}

			&.moveLeft{
				animation-name:moveLeft;
				animation-duration:.4s;
				animation-fill-mode: forwards;
        animation-timing-function:ease-out;
			}

			@keyframes moveLeft{
				from{right:5px;}
				to{right:0px;}
			}
		}
	}
	.card-content{
    // padding-right:15px;
		flex: 1 0 auto;
		p.card-content-text{
			margin:0;
			letter-spacing:1px;
		}
  }
  .title {
    font-size: 1.2em;
  }
}


.minimizedPanel {
  min-width: 150px;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;
}


.el-dialog__title {
  font-size: 1.5em;
}

.handle-button-close {
  width: 48px;
  height: 48px;
  position: absolute;
  opacity: .8;
  top: 50%;
  left: -48px;
  transform: translateY(-50%);
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 1111110;
  pointer-events: auto;
  cursor: pointer;
  line-height: 48px;
  i {
    font-size: 24px;
    line-height: 48px;
  }
}

.detail-sidebar {
  position: relative;
  margin-left: 20px;
  margin-right: 10px;
  min-width: 900px;

  &.fold-right-enter, &.fold-right-leave-to {
    transform: translateX(100%);
    opacity: 0;
  }

  &.fold-right-enter-active, &.fold-right-leave-active {
    transition: all .35s cubic-bezier(.7, .3, .1, 1);
  }
}

.historicalTimePicker {
  &.el-input__inner {
    height: unset !important;
    line-height: unset !important;
    border: unset !important;
  }
  .el-range-input {
    font-size: 13px !important;
    line-height: unset !important;
  }
  .el-range-separator {
    font-size: 13px !important;
    width: auto !important;
  }
}

td {
  div {
    white-space: nowrap;
  }
}
</style>